module.exports = __webpack_public_path__ + "img/curtida.f06b29c5.svg";